import { render, staticRenderFns } from "./Grouping_SideBar.vue?vue&type=template&id=de4f87d2&"
import script from "./Grouping_SideBar.vue?vue&type=script&lang=js&"
export * from "./Grouping_SideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports